var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator, } from "@/components/ui/Breadcrumb";
import { cn } from "@/lib/utils";
import { HomeIcon, SlashIcon } from "lucide-react";
import { useLocation } from "react-router-dom";
export function Breadcrumbs(_a) {
    var pages = _a.pages;
    var pathname = useLocation().pathname;
    var lastBreadcrumbItem = pages.length - 1;
    return (_jsx(Breadcrumb, __assign({ className: "self-start lg:w-[856px] lg:self-center" }, { children: _jsx(BreadcrumbList, __assign({ className: cn("text-xs bg-secondary font-foreground rounded-[8px]", "sm:text-sm") }, { children: pages.map(function (item, idx) { return (_jsxs(_Fragment, { children: [_jsx(BreadcrumbItem, { children: _jsxs(BreadcrumbLink, __assign({ href: item.clickable ? item.path : "#", className: cn("flex items-center gap-2 py-2", idx === 0 && "pl-2", lastBreadcrumbItem === idx && "pr-2", pathname === item.path && "font-bold", !item.clickable &&
                                "cursor-default hover:text-muted-foreground") }, { children: [idx === 0 && _jsx(HomeIcon, { className: "w-4 h-4 stroke-2" }), item.name] })) }, item.path + "item"), lastBreadcrumbItem !== idx && (_jsx(BreadcrumbSeparator, { children: _jsx(SlashIcon, {}) }))] })); }) })) })));
}
